/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".titleTree[_ngcontent-%COMP%]{color:#0076c2;margin-bottom:8px}"];
export { styles as styles };
